export enum IntegrationState {
    NotCreated = 0,
    Created = 1,
    Pending = 2,
    Active = 3,
    Denied = 4,
    Closed = 5,
    Error = 6
}